import { render, staticRenderFns } from "./Integration.vue?vue&type=template&id=965ac2ac&scoped=true"
import script from "./Integration.vue?vue&type=script&lang=js"
export * from "./Integration.vue?vue&type=script&lang=js"
import style0 from "./Integration.vue?vue&type=style&index=0&id=965ac2ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965ac2ac",
  null
  
)

export default component.exports